import {
  getMakerCheckerlList,
  editMakerChecker,
  getApprovalList,
  getPermission,
  executeJobs,
  jobParameters,
  updateJob,
  viewSchedulerJobs,
  updateJobParameters,
  getSchedulerStatus,
  setSchedulerStatus,
  getSchedulerHistpry,
  downloadLogFile,
  getSchedulerJobs,
  editPaymentList,
  onlinePaymentsSearch,
  saveEditPayment,
  downloadData,
  onlinePayment,
  getBulkUploads,
  addBulkUploads,
  viewApprovals,
  paymentListByType,
  processFile,
  getConductorWorkflowStatus,
  getStatusWiseChart,
  getOrderDateFilter,
  getMessageLog,
  getMessageLogSearch,
  getMessageDateFilter,
} from "@/http/admin";
import {
  getAccounting,
  updateProvisioningOrder,
  geteventActionsListData,
  getEventActionsByStatus,
} from "@/http/accounting";

export default {
  namespaced: true,
  state: {
    listToApprove: [],
    makerCheckerList: [],
    messageLogList: [],
    bulkUploads: {
      pageItems: [],
    },
    jobs: [],
    jobDetail: {},
    jobParam: {},
    jobParameters: {},
    scheduler: {},
    schedulerHistory: [],
    payments: {
      pageItems: [],
    },
    onPay: [],
    listing: [],
    eventActionListing: [],
    eventActionByStatus: [],
    approvalsData: null,
    onlinePayents: [],
    autoPayPayments: [],
    conductorWorkflowData: {},
    statusWiseConductorData: {},
    orderDateFilter: {},
  },
  actions: {
    async processFile(_, data) {
      try {
        const resp = await processFile(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async makerCheckerListAction({ commit }) {
      try {
        const resp = await getMakerCheckerlList();
        commit("SET_MAKER_CHECKER_LIST", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getConductorWorkflowStatusAction( { commit }, data) {
      try {
        const resp = await getConductorWorkflowStatus(data);
        commit("SET_CONDUCTOR_WORKFLOW_DATA", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getStatusWiseChartAction( { commit }, data) {
      try {
        const resp = await getStatusWiseChart(data);
        commit("SET_STATUS_WISE_CONDUCTOR_DATA", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getOrderDateFilterAction({ commit }, data) {
      try {
        const resp = await getOrderDateFilter(data);
        commit("SET_ORDER_DATE_FILTER", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getMessageLogAction({ commit }) {
      try {
        const resp = await getMessageLog();
        commit("SET_MESSAGE_LOG_LIST", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getMessageLogSearchAction({ commit }, { messageType, status }) {
  try {
    const res = await getMessageLogSearch(messageType, status);
    commit("SET_MESSAGE_LOG_SEARCH", res.data || []);
  } catch (error) {
    console.error("Error in getMessageLogSearchAction:", error);
    throw error;
  }
},
async getMessageDateFilterAction({ commit }, data) {
    try {
      const res = await getMessageDateFilter(data);
      commit("SET_MESSAGE_LOG_DATE_FILTER", res.data || []);
    } catch (error) {
      console.error("Error in getMessageDateFilterAction:", error);
      throw error;
    }
  },
    async updateMakerCheckerAction(_, payload) {
      try {
        const resp = await editMakerChecker(payload);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getListToApproveAction({ commit }) {
      try {
        const resp = await getApprovalList();
        commit("SET_APPROVAL_LIST", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getPermission(_, payload) {
      try {
        const resp = await getPermission(payload);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setBulkUploads({ commit }) {
      try {
        const resp = await getBulkUploads();
        commit("SET_BULK_UPLOADS", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async addBulkUploadsAction(_, data) {
      try {
        const resp = await addBulkUploads(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async setJobs({ commit }) {
      try {
        const response = await getSchedulerJobs();
        commit("SET_JOBS", response.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setJobDetail({ commit }, data) {
      try {
        const response = await viewSchedulerJobs(data);
        commit("SET_JOB_DETAIL", response.data);
        return response;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setJobParam({ commit }, data) {
      try {
        commit("SET_JOB_PARAM", data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async executeJobsAction(_, data) {
      try {
        const resp = await executeJobs(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getJobParameters({ commit }, data) {
      try {
        const resp = await jobParameters(data);
        commit("SET_JOB_PARAMETERS", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateJobAction({ commit }, data) {
      try {
        const resp = await updateJob(data.id, data.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateJobParameterAction({ commit }, data) {
      try {
        const resp = await updateJobParameters(data.id, data.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getSchedulerState({ commit }, data) {
      try {
        const resp = await getSchedulerStatus(data);
        commit("SET_SCHEDULER", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateScheduler({ commit }, data) {
      try {
        const resp = await setSchedulerStatus(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async schedulerHistoryAction({ commit }, data) {
      try {
        const resp = await getSchedulerHistpry(data);
        commit("SET_SCHEDULER_HISTORY", resp.data.pageItems);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setAccountingAction({ commit }) {
      const resp = await getAccounting();
      commit("SET_ACCOUNTING", resp.data.pageItems);
      return resp;
    },
    async setEventAction({ commit }) {
      try {
        const resp = await geteventActionsListData();
        commit("SET_EVENT", resp.data.pageItems);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setEventActionByStatus({ commit }, source) {
      try {
        const resp = await getEventActionsByStatus(source);
        commit("SET_EVENT_BY_STATUS", resp.data.pageItems);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setUpdateProvisioningOrderAction({ commit }, id, data) {
      try {
        const resp = await updateProvisioningOrder(id, data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async downloadLogAction({ commit }, data) {
      try {
        const resp = await downloadLogFile(data);
        commit("DOWNLOAD_LOG", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setOnlinePayment({ commit }) {
      try {
        const resp = await onlinePayment();
        commit("SET_ONLINE_PAYMENT", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setPaymentListByType({ commit }, payload) {
      try {
        const resp = await paymentListByType(payload);
        commit("SET_ONLINE_PAYMENT_BY_TYPE", {
          data: resp.data.pageItems,
          paymentType: payload.paymentType,
        });
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async viewApprovalsAction({ commit }, payload) {
      try {
        const resp = await viewApprovals(payload);
        commit("SET_APPROVALS_DATA", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async setEditOnPayment({ commit }, payload) {
      try {
        const response = await editPaymentList(payload);
        commit("SET_EDIT_ONLINE", response.data);
        return response;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updatePaymentAction({ commit }, data) {
      try {
        const resp = await saveEditPayment(data.id, data.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateDownloadAction({ commit }, data) {
      try {
        const resp = await downloadData(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async searchOnlinePayments({ commit }, payload) {
      try {
        const response = await onlinePaymentsSearch(payload);
        commit("SET_ONLINE_PAYMENT", response.data);
        return response;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_MAKER_CHECKER_LIST(state, payload) {
      state.makerCheckerList = payload;
    },
    SET_APPROVAL_LIST(state, payload) {
      state.listToApprove = payload;
    },
    SET_MESSAGE_LOG_LIST(state, payload) {
      state.messageLogList = payload;
    },
    SET_MESSAGE_LOG_DATE_FILTER(state, payload) {
      state.messageLogList = payload;
    },
    SET_MESSAGE_LOG_SEARCH(state, payload) {
    state.messageLogList = payload || [];
  },
    SET_BULK_UPLOADS(state, payload) {
      state.bulkUploads = payload;
    },
    SET_JOBS(state, payload) {
      state.jobs = payload;
    },
    SET_JOB_DETAIL(state, payload) {
      state.jobDetail = payload;
    },
    SET_JOB_PARAM(state, payload) {
      state.jobParam = payload;
    },
    // [types.SET_CITY_TEMPLATE] (state, payload) {
    //   Object.assign(state, { cityTemplate: payload })
    // },
    SET_JOB_PARAMETERS(state, payload) {
      state.jobParameters = payload;
    },
    SET_SCHEDULER(state, payload) {
      state.scheduler = payload;
    },
    SET_SCHEDULER_HISTORY(state, payload) {
      state.schedulerHistory = payload;
    },
    SET_ONLINE_PAYMENT(state, payload) {
      state.payments = payload;
    },
    SET_ACCOUNTING(state, payload) {
      state.listing = payload;
    },
    SET_EVENT(state, payload) {
      state.eventActionListing = payload;
    },
    SET_EVENT_BY_STATUS(state, payload) {
      state.eventActionByStatus = payload;
    },
    SET_EDIT_ONLINE(state, payload) {
      state.onPay = payload;
    },
    SET_APPROVALS_DATA(state, payload) {
      state.approvalsData = payload;
    },
    SET_CONDUCTOR_WORKFLOW_DATA(state, payload) {
      state.conductorWorkflowData = payload;
    },
    SET_STATUS_WISE_CONDUCTOR_DATA(state, payload) {
      state.statusWiseConductorData = payload;
    },
    SET_ORDER_DATE_FILTER(state, payload) {
      state.listing = payload.pageItems;
    },
    SET_ONLINE_PAYMENT_BY_TYPE(state, payload) {
      // state.approvalsData = payload;
      if (payload.paymentType == "Online") {
        state.onlinePayents = payload.data;
      } else {
        state.autoPayPayments = payload.data;
      }
    },
  },
  getters: {
    getBulkUploads(state) {
      return state.bulkUploads;
    },
    getJobs(state) {
      return state.jobs;
    },
    getJobDetail(state) {
      return state.jobDetail;
    },
    getJobParam(state) {
      return state.jobParam;
    },
    onlinePayment(state) {
      return state.payments;
    },
    editPaymentList(state) {
      return state.onPay;
    },
  },
};
